import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const TL = (v) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }).format(v || 0);

export default function KasaPage() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 900);
  const [hareketler, setHareketler] = useState([]);
  const [ozet, setOzet] = useState({ toplam_giris: 0, toplam_cikis: 0 });
  const [bakiye, setBakiye] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ tip: 'giris', tutar: '', aciklama: '', kategori: 'diger', tarih: new Date().toISOString().slice(0, 10) });
  const [filtre, setFiltre] = useState({ tip: '', tarih_bas: '', tarih_bit: '' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams(Object.fromEntries(Object.entries(filtre).filter(([, v]) => v)));
      const r = await axios.get(`/muhasebe/kasa?${params}`);
      if (r.data.success) { 
        setHareketler(r.data.data); 
        setOzet(r.data.ozet); 
        setBakiye(r.data.bakiye); 
      }
    } catch (e) { 
      toast.error("Veriler yüklenirken hata oluştu.");
    } finally { 
      setLoading(false); 
    }
  }, [filtre]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleSubmit = async () => {
    if (!form.tutar || !form.aciklama) { toast.error('Tutar ve açıklama zorunlu'); return; }
    try {
      await axios.post('/muhasebe/kasa', form);
      toast.success('Hareket eklendi');
      setShowForm(false); 
      setForm({ tip: 'giris', tutar: '', aciklama: '', kategori: 'diger', tarih: new Date().toISOString().slice(0, 10) });
      load();
    } catch (e) { toast.error('Ekleme hatası'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bu kasa hareketini tamamen silmek istediğinize emin misiniz?")) return;
    try {
      // route dosyasında /muhasebe/kasa/:id olarak tanımlı olduğundan emin olun
      const r = await axios.delete(`/muhasebe/kasa/${id}`);
      if (r.data.success) {
        toast.success('İşlem silindi');
        load();
      }
    } catch (e) {
      const msg = e.response?.data?.message || 'Silme işlemi başarısız';
      toast.error(msg);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="section-header animate-fadeInUp">
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontWeight: 900 }}>🏦 Kasa & Banka</h2>
          <div className="section-subtitle">Tüm nakit hareketleri</div>
        </div>
        <button className="btn btn-primary" style={{ width: isMobile ? '100%' : 'auto', justifyContent: isMobile ? 'center' : 'flex-start' }} onClick={() => setShowForm(s => !s)}>{showForm ? 'Kapat' : '+ Hareket Ekle'}</button>
      </div>

      <div className="card animate-fadeInUp stagger-1" style={{
        background: bakiye >= 0 ? 'linear-gradient(135deg,#10B981,#059669)' : 'linear-gradient(135deg,#EF4444,#DC2626)',
        color: 'white', padding: 24,
      }}>
        <div style={{ fontSize: '0.85rem', opacity: .8, marginBottom: 8 }}>Güncel Kasa Bakiyesi</div>
        <div style={{ fontFamily: 'var(--font-ui)', fontWeight: 900, fontSize: '2.5rem' }}>{TL(bakiye)}</div>
        <div className="muh-filter-row" style={{ gap: 24, marginTop: 16, opacity: .9 }}>
          <div><div style={{ fontSize: '0.75rem' }}>Toplam Giriş</div><div style={{ fontFamily: 'var(--font-ui)', fontWeight: 800 }}>{TL(ozet.toplam_giris)}</div></div>
          <div><div style={{ fontSize: '0.75rem' }}>Toplam Çıkış</div><div style={{ fontFamily: 'var(--font-ui)', fontWeight: 800 }}>{TL(ozet.toplam_cikis)}</div></div>
        </div>
      </div>

      {showForm && (
        <div className="card animate-fadeInUp" style={{ border: '1.5px solid var(--blue)' }}>
          <div style={{ fontWeight: 800, marginBottom: 14 }}>+ Yeni Kasa Hareketi</div>
          <div className="muh-grid-3">
            <div className="form-group">
              <label className="form-label">Tür</label>
              <select className="form-input" value={form.tip} onChange={e => setForm(f => ({ ...f, tip: e.target.value }))}>
                <option value="giris">📥 Giriş</option>
                <option value="cikis">📤 Çıkış</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Tutar (₺)</label>
              <input className="form-input" type="number" value={form.tutar} onChange={e => setForm(f => ({ ...f, tutar: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="form-label">Tarih</label>
              <input className="form-input" type="date" value={form.tarih} onChange={e => setForm(f => ({ ...f, tarih: e.target.value }))} />
            </div>
            <div className="form-group" style={{ gridColumn: '1/-1' }}>
              <label className="form-label">Açıklama</label>
              <input className="form-input" value={form.aciklama} onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 12 }}>
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>İptal</button>
            <button className="btn btn-primary" onClick={handleSubmit}>💾 Ekle</button>
          </div>
        </div>
      )}

      <div className="card animate-fadeInUp stagger-1 muh-filter-row" style={{ padding: '12px 16px' }}>
        <select className="form-input" style={{ width: isMobile ? '100%' : 140, height: 36 }} value={filtre.tip} onChange={e => setFiltre(f => ({ ...f, tip: e.target.value }))}>
          <option value="">Tüm Hareketler</option>
          <option value="giris">📥 Giriş</option>
          <option value="cikis">📤 Çıkış</option>
        </select>
        <input className="form-input" type="date" style={{ width: isMobile ? '100%' : 150, height: 36 }} value={filtre.tarih_bas} onChange={e => setFiltre(f => ({ ...f, tarih_bas: e.target.value }))} />
        <input className="form-input" type="date" style={{ width: isMobile ? '100%' : 150, height: 36 }} value={filtre.tarih_bit} onChange={e => setFiltre(f => ({ ...f, tarih_bit: e.target.value }))} />
        <button className="btn btn-ghost btn-sm" style={{ width: isMobile ? '100%' : 'auto', justifyContent: isMobile ? 'center' : 'flex-start' }} onClick={() => setFiltre({ tip: '', tarih_bas: '', tarih_bit: '' })}>✕</button>
      </div>

      <div className="card animate-fadeInUp stagger-2" style={{ padding: 0 }}>
        {loading ? (
          <div className="page-loader" style={{ minHeight: 200 }}><div className="spinner" /></div>
        ) : hareketler.length === 0 ? (
          <div className="empty-state" style={{ padding: 56 }}><div style={{ fontSize: '3rem' }}>🏦</div><h3>Hareket yok</h3></div>
        ) : isMobile ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 12 }}>
            {hareketler.map((h, i) => (
              <div key={h.id || i} style={{ border: '1px solid var(--border)', borderLeft: `4px solid ${h.tip === 'giris' ? '#10B981' : '#EF4444'}`, borderRadius: 12, padding: 12, background: '#fff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                  <div style={{ fontWeight: 800 }}>{h.aciklama}</div>
                  <div style={{ fontWeight: 900, color: h.tip === 'giris' ? '#10B981' : '#EF4444' }}>{h.tip === 'giris' ? '+' : '-'}{TL(h.tutar)}</div>
                </div>
                <div style={{ marginTop: 6, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                  {new Date(h.tarih || h.created_at).toLocaleDateString('tr-TR')} · {h.kategori || '—'}
                </div>
                <div style={{ marginTop: 4, fontSize: '0.76rem', color: 'var(--text-muted)' }}>
                  {h.kaydeden_ad} {h.kaydeden_soyad}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                  <button className="btn btn-ghost btn-sm" onClick={() => handleDelete(h.id)} style={{ color: '#EF4444' }}>Sil</button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead><tr><th>Tarih</th><th>Açıklama</th><th>Kategori</th><th>Kaydeden</th><th style={{ textAlign: 'right' }}>Tutar</th><th style={{ width: 80, textAlign: 'center' }}>İşlem</th></tr></thead>
              <tbody>
                {hareketler.map((h, i) => (
                  <tr key={h.id || i} style={{ borderLeft: `4px solid ${h.tip === 'giris' ? '#10B981' : '#EF4444'}` }}>
                    <td style={{ fontSize: '0.82rem' }}>{new Date(h.tarih || h.created_at).toLocaleDateString('tr-TR')}</td>
                    <td>
                      <div>{h.aciklama}</div>
                      {h.referans_tip && <div style={{fontSize:'0.65rem', color:'var(--text-muted)'}}>{h.referans_tip.toUpperCase()}</div>}
                    </td>
                    <td style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{h.kategori}</td>
                    <td style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{h.kaydeden_ad} {h.kaydeden_soyad}</td>
                    <td style={{ textAlign: 'right', fontFamily: 'var(--font-ui)', fontWeight: 900, color: h.tip === 'giris' ? '#10B981' : '#EF4444', fontSize: '0.95rem' }}>
                      {h.tip === 'giris' ? '+' : '-'}{TL(h.tutar)}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <button className="btn btn-ghost btn-sm" onClick={() => handleDelete(h.id)} style={{ color: '#EF4444' }}>Sil</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
